<template>
  <el-col :span="normalizedSpan">
    <el-form-item :prop="name" :label="label" :label-width="labelWidth" :required="required" :rules="normalizedRules">
      <OTextarea v-model="model" :maxlength="maxlength" :placeholder="placeholder" :disabled="normalizedDisabled"
        :rows="rows" @change="(attrs.onChange)"></OTextarea>
    </el-form-item>
  </el-col>
</template>

<script setup lang="ts">
import { ElCol, ElFormItem } from 'element-plus'
import type { FormTextareaProps } from './Textarea'
import OTextarea from '../../Input/Textarea/Textarea.vue'
import { useFormItemSpan, useFormItemRules, useFormItemModel, useFormItemDisabled } from '../hooks'
import { useAttrs } from 'vue'

defineOptions({ name: 'OFormTextarea', inheritAttrs: false })
const attrs = useAttrs()

const { name, label, labelWidth, required, maxlength, placeholder, rows } = defineProps<FormTextareaProps>()
const normalizedSpan = useFormItemSpan()
const normalizedRules = useFormItemRules()
const normalizedDisabled = useFormItemDisabled()
const model = useFormItemModel()
</script>
